module.exports = __webpack_public_path__ + "static/media/select-box-checked.76ad1fa6.svg";